var _rect, _g, _path, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreditCard(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1453_38973",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1453_38973)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 7H2V6C2 5.448 2.449 5 3 5H21C21.551 5 22 5.448 22 6V7ZM13 13C13.552 13 14 13.448 14 14C14 14.551 13.552 15 13 15C12.448 15 12 14.551 12 14C12 13.448 12.448 13 13 13ZM22 18C22 18.552 21.551 19 21 19H3C2.449 19 2 18.552 2 18V9H22V18ZM17 13C17.552 13 18 13.448 18 14C18 14.551 17.552 15 17 15C16.448 15 16 14.551 16 14C16 13.448 16.448 13 17 13ZM21 3H3C1.344 3 0 4.344 0 6V18C0 19.656 1.344 21 3 21H21C22.656 21 24 19.656 24 18V6C24 4.344 22.656 3 21 3ZM13 17C13.771 17 14.469 16.7 15 16.221C15.531 16.7 16.229 17 17 17C18.656 17 20 15.656 20 14C20 12.343 18.656 11 17 11C16.229 11 15.531 11.3 15 11.779C14.469 11.3 13.771 11 13 11C11.344 11 10 12.343 10 14C10 15.656 11.344 17 13 17Z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1453_38973",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 3,
    width: 24,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 7H2V6C2 5.448 2.449 5 3 5H21C21.551 5 22 5.448 22 6V7ZM13 13C13.552 13 14 13.448 14 14C14 14.551 13.552 15 13 15C12.448 15 12 14.551 12 14C12 13.448 12.448 13 13 13ZM22 18C22 18.552 21.551 19 21 19H3C2.449 19 2 18.552 2 18V9H22V18ZM17 13C17.552 13 18 13.448 18 14C18 14.551 17.552 15 17 15C16.448 15 16 14.551 16 14C16 13.448 16.448 13 17 13ZM21 3H3C1.344 3 0 4.344 0 6V18C0 19.656 1.344 21 3 21H21C22.656 21 24 19.656 24 18V6C24 4.344 22.656 3 21 3ZM13 17C13.771 17 14.469 16.7 15 16.221C15.531 16.7 16.229 17 17 17C18.656 17 20 15.656 20 14C20 12.343 18.656 11 17 11C16.229 11 15.531 11.3 15 11.779C14.469 11.3 13.771 11 13 11C11.344 11 10 12.343 10 14C10 15.656 11.344 17 13 17Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1453_38973)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/credit_card.524e611f2ec9807fe9913c5a7f8091c7.svg";
export { ForwardRef as ReactComponent };